<article *ngIf="prog">

    <!-- Desktop cards start-->
    <div class="cards">
        <ng-container *ngFor="let item of prog">
            <!-- Desktop pre test start -->
            <div class="cards__item d-flex" *ngIf="item?.type == 'PRE'"
                [ngClass]="{'is-enabled current-task': !item?.status?.islock && (item?.status?.progress < 100), 'is-done': item?.status?.progress ==100,'is-locked':item?.status?.islock}">

                <p class="cards__icon--bg"></p>

                <div class="cards__item--info position-relative pd-t20 pd-b20 pd-l30">
                    <div class="cards__item--infobox position-relative d-flex light-bg">
                        <!-- <div class="locked-overlay"></div> -->
                        <div class="card__item--img">
                            <!-- <img src="assets/images/e8c64c.png" alt=""> -->
                            <span class="cards__item--timer primary-color light-bg link-no-underline cursor-pointer">
                                {{(item.duration <= 3600)?(item.duration |
                                    formateSeconds: 'absoluteMinutes' ):(item.duration |
                                    formateSeconds: 'hourMinute' )}} </span>
                                    <img style="max-width: 340px;" class="cursor-pointer" src="assets/images/revamp/basecamp.png" alt="basecamp">

                        </div>
                        <div class="card__item--right">
                            <div class="">
                                <!-- <p class="mandatory" *ngIf="!item?.isOptionalToComplete">mandatory</p> -->
                                <ul class="card__item--details dark-color">
                                    <li>
                                        {{item.totalQuestions}}
                                        {{(item?.totalQuestions > 1) ?
                                        'Questions' : 'Question' }}</li>
                                    <li class="mandatory card__item--details-orange"
                                        *ngIf="!item?.isOptionalToComplete">mandatory</li>
                                    <!-- <li class="d-inline pd-l10 pd-r10">Estimated Time:
                                {{(prog?.benchmarkingAssessments[0]?.exercise?.duration /
                                60) | number : '1.0-0'}} min </li> -->
                                    <!-- <li class="d-inline pd-l10 pd-r10">Estimated Time123: {{item?.exercise?.duration |
                                    formateSeconds: 'absoluteMinutes'}}</li> -->
                                    <li class="recommendText" *ngIf="(item?.deadLineDate|date: 'shortDate') >= todayDate &&
                                        prog.activation.enableProgramTimer &&
                                        item?.status?.progress!=100">
                                        <span class="material-symbols-outlined">
                                            event_available
                                        </span> <span>{{item?.deadLineDate|date: 'd/M/yy'}}</span>
                                    </li>
                                </ul>
                                <p class="card__item--title dark-color">
                                    {{item?.title || 'Basecamp'}}
                                </p>
                                <p class="card__item--desc dark-color">{{ item?.description ? item?.description :
                                    'Answer these questions and see how you fare on Thrive Skills.'}}</p>
                            </div>
                            <a *ngIf="item?.status?.progress<100 || (prog.activation?.showPrePostTestResults != false && item?.status?.progress==100)"
                                (click)="navigateToPreTest(item)"
                                class="card__item--link link-no-underline text-center cursor-pointer">
                                {{(item?.status?.started &&
                                item?.status?.progress < 100 ) ? 'RESUME TEST' : (item?.status?.progress==100)
                                    ? 'VIEW FEEDBACK' : 'BEGIN TEST' }} </a>
                        </div>
                    </div>
                    <!-- <div class="is-locked-warning position-relative bottom--msg" *ngIf="item?.status?.msg">
                        <a class="link-no-underline">
                            <span class="icon-warning font-10 lock-icon"></span>
                            {{item?.status?.msg}}
                        </a>
                    </div> -->
                </div>
            </div>
            <!-- Desktop pre test end -->

            <!-- Desktop Custom Assessment start -->
            <div class="cards__item d-flex" *ngIf="item?.type == 'ASSESSMENT'"
                [ngClass]="{'is-enabled current-task': !item.status.islock && (item?.status?.progress < 100), 'is-done': item.status.progress ==100,'is-locked':item.status.islock}">
                <p class="cards__icon--bg"></p>
                <div class="cards__item--info position-relative pd-t20 pd-b20 pd-l30">
                    <div class="cards__item--infobox position-relative d-flex light-bg">
                        <!-- <div class="locked-overlay"></div> -->
                        <div class="card__item--img">
                            <span class="cards__item--timer primary-color light-bg link-no-underline cursor-pointer">
                                {{item?.exercise.duration |
                                formateSeconds: 'absoluteMinutes'}}
                            </span>
                            <img style="max-width: 340px;"  class="cursor-pointer" src="assets/images/revamp/assessment.png" alt="assessment">
                        </div>
                        <div class="card__item--right">
                            <div>
                                <!-- <p class="mandatory" *ngIf="!item?.isOptionalToComplete">mandatory</p> -->
                                <ul class="card__item--details dark-color"
                                    *ngIf="activationInfo?.showAssessmentDuration">
                                    <li>
                                        {{item?.totalQuestions}}
                                        {{(item?.totalQuestions > 1) ?
                                        'Questions' : 'Question' }}</li>
                                    <li class="mandatory card__item--details-orange"
                                        *ngIf="!item?.isOptionalToComplete">mandatory</li>
                                    <!-- <li>Estimated Time: {{item?.exercise?.duration |
                                    formateSeconds: 'absoluteMinutes'}}</li> -->
                                </ul>
                                <p class="card__item--title dark-color">
                                    {{item?.exerciseAlias ? item.exerciseAlias : 'Assessment'}} - {{item?.title}}
                                </p>
                                <p class="card__item--desc" *ngIf="activationInfo?.showCustomAssessmentDescription">
                                    {{item?.description ? item.description : 'Answer these questions and see how you fare on Thrive Skills.'}}</p>
                            </div>
                            <a (click)="navigateToAssessment(item)"
                                class="card__item--link link-no-underline primary-color text-center cursor-pointer">
                                {{(item?.status?.started &&
                                item?.status?.progress < 100 ) ? 'RESUME TEST' : (item?.status?.progress==100)
                                    ? 'VIEW FEEDBACK' : 'BEGIN TEST' }} </a>
                        </div>
                    </div>
                    <div class="is-locked-warning position-relative bottom--msg" *ngIf="item?.status?.msg">
                        <a class="link-no-underline">
                            <span class="icon-warning font-10 lock-icon"></span>
                            {{item?.status?.msg}}
                        </a>
                    </div>
                </div>
            </div>
            <!-- Desktop Custom Assessment end -->

            <!-- Desktop hiration start -->
            <div class="cards__item d-flex" *ngIf="item?.type == 'INTEGRATION'"
                [ngClass]="{'is-enabled current-task': !item?.status?.islock && (item?.status?.progress < 100), 'is-done': item?.status?.progress ==100,'is-locked':item?.status?.islock}">

                <p class="cards__icon--bg"></p>

                <div class="cards__item--info position-relative pd-t20 pd-b20 pd-l30">
                    <div
                        class="cards__item--infobox br-5 position-relative d-flex mg-r20 pd-t15 pd-b25 pd-l20 pd-r20 light-bg">
                        <div class="locked-overlay"></div>
                        <div class="card__item--img">
                            <!-- <img src="assets/images/e8c64c.png" alt=""> -->
                            <span class="cards__item--timer primary-color light-bg link-no-underline cursor-pointer">
                                {{(item.duration <= 3600)?(item.duration | formateSeconds: 'absoluteMinutes'
                                    ):(item.duration | formateSeconds: 'hourMinute' )}} </span>
                                    <!-- <img class="cursor-pointer" src="assets/images/pre-program-assessment-icon.png" alt="basecamp"> -->
                                    <img style="max-width: 340px;" [src]="item?.introVideoThumbnailUrl" (click)="showModal(item)" alt=""
                                        class="cursor-pointer">
                                    <img style="max-width: 340px;" (click)="showModal(item)" *ngIf="!item.courseDisableIntroVideo"
                                        class="player_gif" src="/assets/images/gif/play_circle.svg">
                        </div>
                        <div class="card__item--right">

                            <div class="mg-l20 mg-r20 pd-r120">
                                <p class="card__item--title dark-color">
                                    {{item?.title || ''}}</p>
                                <!-- <p class="mandatory" *ngIf="!item?.isOptionalToComplete">mandatory</p> -->
                                <ul class="card__item--details dark-color">
                                    <li class="recommendText" *ngIf="(item?.deadLineDate|date: 'shortDate') >= todayDate &&
                                      prog.activation.enableProgramTimer &&
                                      item?.status?.progress!=100">
                                        Recommended to complete by <span>{{item?.deadLineDate|date: 'd/M/yy'}}</span>
                                    </li>
                                    <li class="mandatory card__item--details-orange"
                                        *ngIf="!item?.isOptionalToComplete">mandatory</li>

                                </ul>
                                <p class="card__item--desc">{{ item?.description ? item?.description : ''}}</p>
                            </div>
                            <a (click)="startIntegration('dashboard/hiration', item)"
                                class="card__item--link pd-t10 pd-b10 link-no-underline primary-color text-center cursor-pointer">
                                {{(item?.status?.started &&
                                item?.status?.progress < 100 ) ? 'RESUME' : (item?.status?.progress==100)
                                    ? 'VIEW FEEDBACK' : 'START' }} </a>
                        </div>
                    </div>
                    <!-- <div class="is-locked-warning position-relative bottom--msg" *ngIf="item?.status?.msg">
                      <a class="link-no-underline">
                          <span class="icon-warning font-10 lock-icon"></span>
                          {{item?.status?.msg}}
                      </a>
                  </div> -->
                </div>
            </div>
            <!-- Desktop hiration end -->

            <!-- desktop course card start -->
            <div class="cards__item d-flex " *ngIf="item?.type == 'COURSE'"
                [ngClass]="{'is-enabled current-task': !item.status.islock && !item.status.started ,'is-started': item.status.progress < 100 && item.status.started, 'is-done': item.status.progress ==100,'is-locked':item.status.islock }">
                <p class="cards__icon--bg"></p>

                <div class="is-started-progress ">
                    <circle-progress [percent]="item?.status?.progress|number:'1.0-0'" [radius]="19" [space]="-3"
                        [toFixed]="0" [maxPercent]="100" [unitsFontSize]="9" [unitsColor]="'#44A659'"
                        [outerStrokeWidth]="4" [outerStrokeColor]="'#44A659'" [innerStrokeColor]="'#D5D5D5'"
                        [innerStrokeWidth]="1" [titleColor]="'#44A659'" [titleFontSize]="12" [subtitleFontSize]="6">
                    </circle-progress>
                </div>

                <div class="cards__item--info position-relative pd-t20 pd-b20 pd-l30">
                    <div class="cards__item--infobox position-relative d-flex light-bg course__wrap"
                        [ngClass]="{'no-habit-drills-pad br-5': item?.courseHabitDrills && !item?.courseHabitDrills.length }">
                        <!-- <div class="locked-overlay"></div> -->
                        <div class="card__item--img">
                            <span class="cards__item--timer primary-color light-bg link-no-underline cursor-pointer">
                                {{(item.duration <= 3600)?(item.duration | formateSeconds: 'absoluteMinutes'
                                    ):(item.duration | formateSeconds: 'hourMinute' )}} </span>
                                    <!-- <a class="cards__item--trailer primary-color light-bg link-no-underline cursor-pointer"
                                (click)="showModal(item)" *ngIf="!item.courseDisableIntroVideo">COURSE PREVIEW</a> -->
                                    <img style="max-width: 340px;" [src]="item?.introVideoThumbnailUrl" (click)="showModal(item)" alt=""
                                        class="cursor-pointer">
                                    <img style="max-width: 340px;" (click)="showModal(item)" *ngIf="!item.courseDisableIntroVideo"
                                        class="player_gif" src="/assets/images/revamp/course-play-icon.png">
                        </div>
                        <div class="card__item--right">

                            <div class="">
                                <!-- <p class="mandatory" *ngIf="!item?.isOptionalToComplete">mandatory</p> -->
                                <ul class="card__item--details">
                                    <!-- <li class="d-inline pd-l10 pd-r10">5 Questions</li> -->
                                    <!-- <li class="d-inline pd-l10 pd-r10">Estimated Time: {{(item?.duration / 60) | number :
                                    '1.0-0'}} min</li> -->
                                    <!-- <li *ngIf="item?.duration <= 3600" class="d-inline pd-l10 pd-r10">Estimated Time123:
                                    {{item?.duration | formateSeconds: 'absoluteMinutes'}}</li>
                                <li *ngIf="item?.duration > 3600" class="d-inline pd-l10 pd-r10">Estimated Time123:
                                    {{item?.duration | formateSeconds: 'hourMinute'}}</li> -->
                                    <li class="mandatory card__item--details-orange"
                                        *ngIf="!item?.isOptionalToComplete">mandatory</li>
                                    <li class="recommendText" *ngIf="(item?.deadLineDate|date: 'shortDate') >= todayDate &&
                                        prog.activation.enableProgramTimer &&
                                        item?.status?.progress!=100">
                                        Recommended to complete by <span>{{item?.deadLineDate|date: 'd/M/yy'}}</span>
                                    </li>
                                </ul>
                                <p class="card__item--title dark-color">{{item?.title|lowercase}}</p>

                                <p class="card__item--desc">{{item?.description}}</p>
                            </div>
                            <div class="card__item--right-bottom">
                                <a (click)="startCourse('COURSE', item?.courseId, item?.programDashboardId, item, $event)"
                                    class="card__item--link link-no-underline primary-color text-center cursor-pointer">
                                    {{(item?.status?.started && item?.status?.progress < 100 ) ? 'RESUME LEARNING' :
                                        (item?.status?.progress==100) ? 'REVISE' : 'START LEARNING' }} </a>

                                        <span class="wrap-flex is-enabled--msg {{item?.type?.toLowerCase()}}"
                                            *ngIf="item?.courseHabitDrills && item?.courseHabitDrills.length">
                                            <!-- <div class="locked-overlay"></div> -->
                                            <ng-container *ngFor="let habit of item?.courseHabitDrills; let i = index">
                                                <a (click)="habitDrillDetails(item, habit)" target="_blank"
                                                    class="link-no-underline cursor-pointer">
                                                     <span *ngIf="item.status.progress != 100" class="icon-padlock-1 font-10 lock-icon"></span>
                                                     <span *ngIf="item.status.progress == 100" class="material-symbols-outlined font-10">
                                                        lock_open
                                                        </span>
                                                    {{dynamicHabitDrillNomenclature}} {{i+1}}
                                                </a>
                                            </ng-container>
                                        </span>
                            </div>
                        </div>
                    </div>
                    <div class="is-locked-warning position-relative" *ngIf="item?.status?.msg"
                        [ngClass]="{'no-habit-drills': item?.courseHabitDrills && !item?.courseHabitDrills.length }">
                        <a class="link-no-underline">
                            <span class="icon-warning font-10 lock-icon"></span>
                            {{item?.status?.msg}}
                        </a>
                    </div>
                    <!-- <div class="is-locked-warning position-relative" *ngIf="item.courseId == lockedCardMsg.courseId"
                        [ngClass]="{'no-habit-drills': item?.courseHabitDrills && !item?.courseHabitDrills.length }">
                        <a class="link-no-underline" *ngIf="lockedCardMsg.type == 'PRE'">
                            <span class="icon-warning font-10 lock-icon"></span>
                            {{lockedCardMsg.msg}}
                        </a>
                        <a class="link-no-underline" *ngIf="lockedCardMsg.type == 'SEQUENCE'">
                            <span class="icon-warning font-10 lock-icon"></span>
                            Complete {{lockedCardMsg.courseName | titlecase}} to unlock this course
                        </a>
                        <a class="link-no-underline" *ngIf="lockedCardMsg.type == 'DATE'">
                            <span class="icon-warning font-10 lock-icon"></span>
                            {{lockedCardMsg.msg}} {{lockedCardMsg.date | date: 'EEEE, MMMM d, y'}}
                            {{(lockedCardMsg?.dateNotPassed) ? ', after completing the '+ preTitle +'.' : '' }}
                        </a>
                    </div>
                    <div class="is-locked-warning position-relative"
                        *ngIf="(item.courseId != lockedCardMsg.courseId) && prog?.activation?.courseUnlockType == 'DATE' && item?.status?.islock">
                        <a class="link-no-underline">
                            <span class="icon-warning font-10 lock-icon"></span>
                            <ng-container *ngIf="item?.isPreDone && !item?.isDatePassed">
                                This course will unlock on {{ item.course_StartDate | date: 'EEEE, MMMM d, y'}}
                            </ng-container>
                            <ng-container *ngIf="!item?.isPreDone && !item?.isDatePassed">
                                This course will unlock on {{ item.course_StartDate | date: 'EEEE, MMMM d, y'}}, after
                                completing the {{preTitle}}.
                            </ng-container>
                            <ng-container *ngIf="!item?.isPreDone && item?.isDatePassed">
                                This course will unlock after completing the {{preTitle}}.
                            </ng-container>
                        </a>
                    </div> -->
                </div>
            </div>
            <!-- desktop course card end -->

            <!-- desktop masterclass card start -->
            <div class="cards__item d-flex" *ngIf="item?.type == 'MASTERCLASS'"
                [ngClass]="{'is-disabled-live':item.status.islock,'is-enabled-live current-task': (item.status.started || !item.status.islock) && item.status.progress < 100 , 'is-done-live': item.status.progress==100}">
                <p class="cards__icon--bg"></p>
                <div class="cards__item--info position-relative pd-t20 pd-b20 pd-l30">
                    <div class="cards__item--infobox cards__item--infobox--disabled position-relative"
                        [ngClass]="{'no-habit-drills-pad': item?.courseHabitDrills && !item?.courseHabitDrills.length }">
                        <div class="locked-overlay"></div>
                        <div
                            class="cards__item--infobox--innerdiv position-relative d-flex justify-content-between flex-column">
                            <!-- <div style="margin: 9px 5px 9px 15px;width: 370px;"> -->
                            <div>
                                <ul class="card__item--details masterclass-started dark-color"
                                    *ngIf="!item?.isOptionalToComplete">
                                    <li
                                        *ngIf="item.masterClassObjects && !item.masterClassObjects[0]?.recordedLink && !item.status.islock && !item.status.upcoming && !item.status.isMeetingEnd">
                                        <a class="item-live live-top link-no-underline dark-color">
                                            {{item.masterClassObjects && !item.masterClassObjects[0]?.recordedLink && !item.status.islock && !item.status.upcoming ?'Live Masterclass' : ''}}
                                        </a>
                                    </li>
                                    <li class="mandatory card__item--details-orange"
                                        *ngIf="!item?.isOptionalToComplete">mandatory
                                      </li>
                                    <!-- <li class="mandatory card__item--details-light--blue">live masterclass
                                      </li> -->
                                      <li *ngIf="item?.masterClassObjects && item?.masterClassObjects.length" class="mandatory card__item--details-duration">
                                        {{ getTimeDifference(item?.masterClassObjects[0]?.endDate,item?.masterClassObjects[0]?.date)}}
                                      </li>

                                </ul>
                                <p class="card__item--title dark-color">{{item?.masterclassAlias ? item.masterclassAlias
                                    : 'Masterclass'}} - {{item?.title}}
                                </p>
                                <div>
                                    <div class="card__item--details masterclass-ended dark-color"
                                        *ngIf="item?.status?.isMeetingEnd">
                                        <span class=""
                                            *ngIf="item?.masterClassObjects && item?.masterClassObjects.length">
                                            {{item?.masterclassAlias ? item.masterclassAlias : 'Masterclass'}}
                                            ended at
                                            {{ item?.masterClassObjects[0]?.endDate | date: dateFormat}}</span>

                                    </div>
                                    <div class="card__item--details masterclass-ended dark-color"
                                        *ngIf="!item?.status?.isMeetingEnd">
                                        <span class=""
                                            *ngIf="item?.masterClassObjects && item?.masterClassObjects.length && item?.masterClassObjects[0]?.date">Scheduled at
                                            {{item?.masterClassObjects[0]?.date | date:'shortTime'}},
                                            {{item?.masterClassObjects[0]?.date | date:'d LLLL yyyy'}}</span>
                                    </div>
                                </div>

                            </div>
                            <div class="cards__item--rightside position-relative">
                                <a class="live-btn card__item--link link-no-underline text-center cursor-pointer"
                                    (click)="startZoom(item?.masterClassObjects[0]._id, item.programDashboardId, item)">
                                    {{ item.masterClassObjects && item.masterClassObjects[0]?.recordedLink && item.masterClassObjects[0]?.recordedLink!=='' ? 'Watch Recording':
                                    item.status.isMeetingEnd ? 'Recording Awaited' :
                                    !item.status.islock && !item.status.upcoming ?'Enter Live Session': 'Upcoming' }} </a>

                                <div class="card__item--disabled--link">
                                    <div class="hover--liveclass">
                                        <a class="seedetailsBtn primary-color link-no-underline cursor-pointer"
                                            *ngIf="item?.masterClassObjects && item?.masterClassObjects.length && item?.masterClassObjects[0]?.date && item?.description && item?.title"
                                            (mouseenter)="masterclassDetailsEvent($event, item)">
                                            VIEW DETAILS</a>
                                        <div class="card__item--hoverspeaker">
                                            <h5 class="card__item--classtitle dark-color">{{item?.masterclassAlias ?
                                                item.masterclassAlias : 'Masterclass'}} - {{item?.title}}
                                            </h5>
                                            <p class="card__item--classdesc dark-color mg-t15"> {{item?.description}}
                                            </p>
                                            <ng-container
                                                *ngIf="item?.masterClassObjects && item?.masterClassObjects.length && item?.masterClassObjects[0]?.date">
                                                <p class="card__item--classdesc masterclass-started dark-color mg-t15"
                                                    *ngIf="!item?.status?.isMeetingEnd">
                                                    Start at {{item?.masterClassObjects[0]?.date | date: dateFormat}}
                                                </p>
                                                <p class="card__item--classdesc masterclass-ended dark-color mg-t15"
                                                    *ngIf="item?.status?.isMeetingEnd">
                                                    {{item?.masterclassAlias ? item.masterclassAlias : 'Masterclass'}}
                                                    ended at {{item?.masterClassObjects[0]?.endDate | date:
                                                    dateFormat}}</p>
                                            </ng-container>
                                            <ng-container
                                                *ngIf="item?.masterClassObjects && item?.masterClassObjects.length && item?.masterClassObjects[0]?.faculty && item?.masterClassObjects[0]?.faculty.name">
                                                <p class="card__item--classdesc dark-color mg-t15">Faculty:</p>
                                                <div class="d-flex card__item--faculty pd-t10">
                                                    <!-- <img src="assets/images/profile.jpg" alt="" -->
                                                    <div class="card__item--faculty--pic">
                                                        <img
                                                            [src]="item?.masterClassObjects && item?.masterClassObjects[0]?.faculty?.profilePic">
                                                    </div>
                                                    <div class="pd-l10">
                                                        <h6 class="card__item--faculty--name">{{item?.masterClassObjects
                                                            &&
                                                            item?.masterClassObjects[0]?.faculty?.name | titlecase}}
                                                        </h6>
                                                        <p class="card__item--faculty--job">{{item?.masterClassObjects
                                                            &&
                                                            item?.masterClassObjects[0]?.faculty?.designation}}
                                                        </p>
                                                        <p class="card__item--faculty--desc">{{item?.masterClassObjects
                                                            &&
                                                            item?.masterClassObjects[0]?.faculty?.shortBio}}</p>
                                                        <a class="cursor-pointer"
                                                            *ngIf="item?.masterClassObjects && item?.masterClassObjects[0]?.faculty?.linkedIn">
                                                            <img src="assets/images/linkedin-full.svg" width="16" alt=""
                                                                (click)="navigateLinkedIn(item?.masterClassObjects[0]?.faculty?.linkedIn)">
                                                        </a>
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </div>
                                    <!-- <a class="item-live link-no-underline light-color"
                                        *ngIf="!item.recordedLink && !item.status.islock && !item.status.upcoming && !item.status.isMeetingEnd">
                                        {{!item.recordedLink && !item.status.islock && !item.status.upcoming ?'Live Noww'
                                        : ''}}
                                    </a> -->
                                </div>
                            </div>
                            <div class="{{item?.type.toLowerCase()}} is-enabled--msg position-relative br-bottom wrap-flex"
                            *ngIf="item?.courseHabitDrills && item?.courseHabitDrills.length">
                            <div class="locked-overlay"></div>
                            <ng-container *ngFor="let habit of item?.courseHabitDrills; let i = index">
                                <a (click)="habitDrillDetails(item, habit)" target="_blank"
                                    class="link-no-underline cursor-pointer">
                                    <span *ngIf="item.status.progress != 100" class="icon-padlock-1 font-10 lock-icon"></span>
                                    <span *ngIf="item.status.progress == 100" class="material-symbols-outlined font-10">
                                       lock_open
                                       </span>
                                    {{dynamicHabitDrillNomenclature}} {{i+1}}
                                </a>
                            </ng-container>
                        </div>

                        </div>

                    </div>

                    <!-- <div class="is-locked-warning position-relative" *ngIf="item?.status?.msg"
                        [ngClass]="{'no-habit-drills': item?.courseHabitDrills && !item?.courseHabitDrills.length }">
                        <a class="link-no-underline">
                            <span class="icon-warning font-10 lock-icon"></span>
                            {{item?.status?.msg}}
                        </a>
                    </div> -->
                </div>
            </div>
            <!-- desktop masterclass card end -->
            <!-- Desktop post expercise card start -->
            <div class="cards__item d-flex" *ngIf="item?.type == 'POST'" [ngClass]="{
                'is-enabled current-task': !item?.status?.islock && (item?.status?.progress < 100),
                'is-locked':item?.status?.islock,
                'is-done':item?.status?.progress == 100}">
                <p class="cards__icon--bg"></p>
                <div class="cards__item--info position-relative pd-t20 pd-b20 pd-l30">
                    <div class="cards__item--infobox br-5 position-relative d-flex light-bg">
                        <!-- <div class="locked-overlay"></div> -->
                        <div class="card__item--img">
                            <span class="cards__item--timer primary-color light-bg link-no-underline cursor-pointer">
                                {{(item.exercise.duration <= 3600)?(item.exercise.duration |
                                    formateSeconds: 'absoluteMinutes' ):(item.exercise.duration |
                                    formateSeconds: 'hourMinute' )}} </span>
                                    <!-- <img src="assets/images/e8c64c.png" alt=""> -->
                                    <!-- <img [src]="prog?.introVideoThumbnailUrl" alt="">    -->
                                    <img style="max-width: 130px;"  src="assets/images/upgradRed/summit.png" alt="submit">
                        </div>
                        <div class="card__item--right">

                            <div>

                                <!-- <p class="mandatory" *ngIf="!item?.isOptionalToComplete">mandatory</p> -->
                                <ul class="card__item--details dark-color">
                                    <li>
                                        {{item?.totalQuestions}}
                                        {{(item?.totalQuestions > 1) ?
                                        'Questions' : 'Question' }}</li>
                                    <li class="mandatory card__item--details-orange"
                                        *ngIf="!item?.isOptionalToComplete">mandatory</li>

                                    <!-- <li class="d-inline pd-l10 pd-r10">Estimated Time:
                                {{(prog?.benchmarkingAssessments[0]?.exercise?.duration /
                                60) | number : '1.0-0'}} min </li> -->
                                    <!-- <li class="d-inline pd-l10 pd-r10">Estimated Time123: {{item?.exercise?.duration |
                                    formateSeconds: 'absoluteMinutes'}}</li> -->
                                    <li class="recommendText" *ngIf="(item?.deadLineDate|date: 'shortDate') >= todayDate &&
                                        prog.activation.enableProgramTimer &&
                                        item?.status?.progress!=100">
                                        Recommended to complete by <span>{{item?.deadLineDate|date: 'd/M/yy'}}</span>
                                    </li>

                                </ul>
                                <p class="card__item--title dark-color">
                                    {{item?.title || 'Summit'}}</p>
                                <p class="card__item--desc">{{ item?.description ? item?.description : 'The program is
                                    over. See how you fare on Thrive Skills now!' }}</p>
                            </div>
                            <div>
                                <a *ngIf="item?.status?.progress<100 || (prog.activation?.showPrePostTestResults != false && item?.status?.progress==100)"
                                    (click)=navigateToPostTest(item)
                                    class="card__item--link link-no-underline primary-color text-center cursor-pointer">
                                    {{(item?.status?.started &&
                                    item?.status?.progress < 100 ) ? 'RESUME TEST' : (item?.status?.progress==100)
                                        ? 'VIEW FEEDBACK' : 'BEGIN TEST' }} </a>
                            </div>
                        </div>
                        <!-- <div class="is-locked-warning position-relative bottom--msg" *ngIf="item?.status?.msg">
                        <a class="link-no-underline">
                            <span class="icon-warning font-10 lock-icon"></span>
                            {{item?.status?.msg}}
                        </a>
                    </div> -->
                    </div>

                </div>
            </div>
            <!-- Desktop post expercise card end -->
        </ng-container>
        <!-- Desktop course/masterclass end -->

        <!-- Desktop certificate start -->
        <div *ngIf="activationInfo?.enableProgramCertificate || activationInfo?.showProgramPerformanceReport"
            class="cards__item is-disabled-reports d-flex" [ngClass]="{
            'is-enabled current-task': activationInfo?.progress == 100 && (activationInfo?.isFeedbackSubmitted || !activationInfo?.enableProgramFeedback),
            'is-disabled':!activationInfo?.progress || activationInfo?.progress < 100
           }">
            <p class="cards__icon--bg"></p>
            <div class="cards__item--info position-relative pd-t20 pd-b20 pd-l30">
                <div class="cards__item--infobox br-5 position-relative d-flex align-items-center light-bg cursor-pointer"
                    (click)="goToReportCertificate()">
                    <!-- <div class="locked-overlay"></div> -->
                    <div class="card__item--img yellow-bg">
                        <!-- <span
                            class="cards__item--timer primary-color light-bg link-no-underline cursor-pointer"> 40 mins
                        </span> -->
                        <img style="max-width: 340px;" src="assets/images/revamp/card-certificate.png" alt="certificate" class="cursor-pointer">
                    </div>
                    <div class="card__item--right">
                        <p class="card__item--title dark-color pd-t20">
                            <!-- <img src="assets/images/medal.svg" width="17" height="20" alt="" class="mg-r10"> -->
                            <ng-container
                                *ngIf="activationInfo?.enableProgramCertificate && activationInfo?.showProgramPerformanceReport">
                                Certificate & Transcript
                            </ng-container>
                            <ng-container
                                *ngIf="!(activationInfo?.enableProgramCertificate && activationInfo?.showProgramPerformanceReport)">
                                {{(activationInfo?.enableProgramCertificate && !isProgramCompletionDatePassed) ||
                                (activationInfo?.enableProgramCertificate && prog[0].status.progress == 100)
                                ?
                                "Certificate" : "Transcript"}}
                            </ng-container>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <!-- Desktop certificate end -->

    </div>
    <!-- Desktop cards end -->

    <!-- Mobile cards start -->
    <div class="cards hideabove900 mg-l15 mg-r15 mg-sm-l20 mg-sm-t15 mg-sm-b15 d-none" >

        <!-- Mobile course / masterclass start -->
        <ng-container *ngFor="let item of prog['dashboard']">
            <!-- Mobile pre test start -->
            <div class="cards__item d-flex" *ngIf="item?.type == 'PRE'"
                [ngClass]="{'is-enabled current-task': !item?.status?.islock && (item?.status?.progress < 100), 'is-done': item?.status?.progress == 100,'is-locked':item?.status?.islock}">

                <p class="cards__icon--bg"></p>
                <div class="cards__item--info position-relative pd-t15 pd-b15 pd-l60">
                    <div
                        class="cards__item--infobox br-5 position-relative d-flex flex-column mg-r20 pd-t15 pd-b15 pd-l15 pd-r15 light-bg">
                        <div class="locked-overlay"></div>
                        <div class="d-flex w-100">
                            <div class="card__item--img">
                                <span
                                    class="cards__item--timer primary-color light-bg link-no-underline cursor-pointer">
                                    {{(item.exercise.duration <= 3600)?(item.exercise.duration |
                                        formateSeconds: 'absoluteMinutes' ):(item.exercise.duration |
                                        formateSeconds: 'hourMinute' )}} </span>
                                        <!-- <img src="assets/images/e8c64c.png" alt=""> -->
                                        <!-- <img [src]="prog?.introVideoThumbnailUrl" alt=""> -->
                                        <img style="max-width: 340px;" class="cursor-pointer" src="assets/images/pre-program-assessment-icon.png"
                                            alt="basecamp">
                            </div>
                            <ul class="card__item--details dark-color time-block">
                                <li class="recommendText pd-l30 pd-b10" *ngIf="(item?.deadLineDate|date: 'shortDate') >= todayDate &&
                                    prog.activation.enableProgramTimer &&
                                    item?.status?.progress!=100">
                                    Recommended to complete by <span>{{item?.deadLineDate|date: 'd/M/yy'}}</span>
                                </li>
                                <li class="d-inline pd-r10">
                                    {{item?.exercise?.totalQuestions}}
                                    {{(item?.exercise?.totalQuestions > 1) ?
                                    'Questions' : 'Question' }}</li>
                                <!-- <li class="pd-l10">Estimated Time: {{prog?.benchmarkingAssessments[0]?.exercise?.duration | formateSeconds: 'absoluteMinutes'}}</li> -->
                            </ul>
                        </div>
                        <div class="mg-t15 card__item--titlebox">
                            <p class="card__item--title dark-color">
                                {{item?.title || 'Basecamp'}}</p>
                            <!-- <p class="mandatory" *ngIf="!item?.isOptionalToComplete">mandatory</p> -->
                            <ul class="card__item--details dark-color">
                                <li class="mandatory card__item--details-orange" *ngIf="!item?.isOptionalToComplete">
                                    mandatory</li>

                                <!-- <li class="d-inline pd-l10 pd-r10">
                                    {{item?.exercise?.pages[0]?.elements?.length}}
                                    {{(item?.exercise?.pages[0]?.elements?.length > 1) ?
                                    'Questions' : 'Question' }}</li> -->
                                <!-- <li class="d-inline pd-l10 pd-r10">Estimated Time:
                            {{(prog?.benchmarkingAssessments[0]?.exercise?.duration /
                            60) | number : '1.0-0'}} min </li> -->
                                <!-- <li class="d-inline pd-l10 pd-r10">Estimated Time123: {{item?.exercise?.duration |
                                    formateSeconds: 'absoluteMinutes'}}</li> -->

                                <p class="card__item--desc time-block">Answer these questions and see how you fare on
                                    Thrive
                                    Skills.</p>
                            </ul>
                        </div>
                        <a *ngIf="item?.status?.progress<100 || (prog.activation?.showPrePostTestResults != false && item?.status?.progress==100)"
                            (click)="navigateToPreTest(item)"
                            class="card__item--link-xs link-no-underline primary-color cursor-pointer">
                            {{(item?.status?.started &&
                            item?.status?.progress < 100 ) ? 'RESUME TEST' : (item?.status?.progress==100)
                                ? 'VIEW FEEDBACK' : 'BEGIN TEST' }} </a>
                    </div>
                    <!-- <div class="is-locked-warning position-relative bottom--msg" *ngIf="item?.status?.msg">
                        <a class="link-no-underline">
                            <span class="icon-warning font-10 lock-icon"></span>
                            {{item?.status?.msg}}
                        </a>
                    </div> -->
                </div>

            </div>
            <!-- Mobile pre test end -->

            <!-- Mobile Custom Assessment start -->
            <div class="cards__item d-flex" *ngIf="item?.type == 'ASSESSMENT'"
                [ngClass]="{'is-enabled current-task': !item.status.islock && (item?.status?.progress < 100), 'is-done': item.status.progress ==100,'is-locked':item.status.islock}">

                <p class="cards__icon--bg"></p>
                <div class="cards__item--info position-relcard__item--title dark-colorative pd-t15 pd-b15 pd-l60">
                    <div
                        class="cards__item--infobox br-5 position-relative d-flex flex-column mg-r20 pd-t15 pd-b15 pd-l15 pd-r15 light-bg">
                        <div class="locked-overlay"></div>
                        <div class="d-flex justify-content-between w-100">
                            <div class="card__item--img">
                                <!-- <img [src]="prog?.introVideoThumbnailUrl" alt=""> -->
                                <img style="max-width: 340px;"  src="assets/images/basecamp.svg" alt="basecamp">
                            </div>
                        </div>
                        <div class="card__item--right">

                            <div class="mg-t15 card__item--titlebox">
                                <p class="card__item--title dark-color">
                                    {{item?.title}}</p>
                                <!-- <p class="mandatory" *ngIf="!item?.isOptionalToComplete">mandatory</p> -->
                                <ul class="card__item--details dark-color"
                                    *ngIf="prog?.activation?.showAssessmentDuration">
                                    <li class="d-inline pd-l10 pd-r10">
                                        {{item?.exercise?.totalQuestions}}
                                        {{(item?.exercise?.totalQuestions > 1) ?
                                        'Questions' : 'Question' }}</li>
                                    <li class="mandatory card__item--details-orange"
                                        *ngIf="!item?.isOptionalToComplete">mandatory</li>

                                    <li class="d-inline pd-l10 pd-r10">Estimated Time: {{item?.exercise?.duration |
                                        formateSeconds: 'absoluteMinutes'}}</li>
                                    <p class="card__item--desc"
                                        *ngIf="prog?.activation?.showCustomAssessmentDescription">{{item?.description ?
                                        item.description : 'Answer these questions and see how you fare on Thrive
                                        Skills.'}}</p>
                                </ul>
                            </div>
                            <a (click)="navigateToAssessment(item)"
                                class="card__item--link-xs link-no-underline primary-color cursor-pointer">
                                {{(item?.status?.started &&
                                item?.status?.progress < 100 ) ? 'RESUME TEST' : (item?.status?.progress==100)
                                    ? 'VIEW FEEDBACK' : 'BEGIN TEST' }} </a>
                        </div>
                    </div>
                    <div class="is-locked-warning position-relative bottom--msg" *ngIf="item?.status?.msg">
                        <a class="link-no-underline">
                            <span class="icon-warning font-10 lock-icon"></span>
                            {{item?.status?.msg}}
                        </a>
                    </div>
                </div>

            </div>
            <!-- Mobile Custom Assessment end -->
            <!-- Mobile hiration start -->
            <div class="cards__item d-flex" *ngIf="item?.type == 'INTEGRATION'"
                [ngClass]="{'is-enabled current-task': !item?.status?.islock && (item?.status?.progress < 100), 'is-done': item?.status?.progress == 100,'is-locked':item?.status?.islock}">
                <p class="cards__icon--bg"></p>
                <div class="cards__item--info position-relative pd-t15 pd-b15 pd-l60">
                    <div
                        class="cards__item--infobox br-5 position-relative d-flex flex-column mg-r20 pd-t15 pd-b15 pd-l15 pd-r15 light-bg">
                        <div class="locked-overlay"></div>
                        <div class="d-flex w-100">
                            <div class="card__item--img">
                                <span
                                    class="cards__item--timer primary-color light-bg link-no-underline cursor-pointer">
                                    {{(item.duration <= 3600)?(item.duration | formateSeconds: 'absoluteMinutes'
                                        ):(item.duration | formateSeconds: 'hourMinute' )}} </span>
                                        <!-- <img class="cursor-pointer" src="assets/images/pre-program-assessment-icon.png" alt="basecamp"> -->
                                        <img style="max-width: 340px;" (click)="showModal(item)" *ngIf="!item.courseDisableIntroVideo"
                                            class="player_gif" src="/assets/images/gif/play_circle.svg">
                                        <img style="max-width: 340px;" [src]="item?.introVideoThumbnailUrl" (click)="showModal(item)" alt=""
                                            class="cursor-pointer">
                            </div>

                            <ul class="card__item--details dark-color time-block">
                                <li class="recommendText pd-l30 pd-b10" *ngIf="(item?.deadLineDate|date: 'shortDate') >= todayDate &&
                                    prog.activation.enableProgramTimer &&
                                    item?.status?.progress!=100">
                                    Recommended to complete by <span>{{item?.deadLineDate|date: 'd/M/yy'}}</span>
                                </li>
                            </ul>
                        </div>
                        <div class="card__item--right">

                            <div class="mg-t15 card__item--titlebox">
                                <p class="card__item--title dark-color">
                                    {{item?.title || ''}}</p>
                                <!-- <p class="mandatory" *ngIf="!item?.isOptionalToComplete">mandatory</p> -->
                                <ul class="card__item--details dark-color">
                                    <li class="mandatory card__item--details-orange"
                                        *ngIf="!item?.isOptionalToComplete">mandatory</li>
                                    <p class="card__item--desc time-block">{{item?.description}}</p>
                                </ul>
                            </div>
                            <a (click)="startIntegration('dashboard/hiration', item)"
                                class="card__item--link-xs link-no-underline primary-color cursor-pointer">
                                {{(item?.status?.started &&
                                item?.status?.progress < 100 ) ? 'RESUME' : (item?.status?.progress==100)
                                    ? 'VIEW FEEDBACK' : 'START' }} </a>
                        </div>
                    </div>
                    <!-- <div class="is-locked-warning position-relative bottom--msg" *ngIf="item?.status?.msg">
                        <a class="link-no-underline">
                            <span class="icon-warning font-10 lock-icon"></span>
                            {{item?.status?.msg}}
                        </a>
                    </div> -->
                </div>
            </div>
            <!-- Mobile hiration end -->

            <!-- Mobile masterclass start -->
            <div class="cards__item  d-flex " *ngIf="item?.type == 'MASTERCLASS'"
                [ngClass]="{'is-disabled-live':item.status.islock,'is-enabled-live current-task': (item.status.started || !item.status.islock) && item.status.progress < 100 , 'is-done-live': item.status.progress==100}">
                <p class="cards__icon--bg"></p>
                <div class="cards__item--info position-relative pd-t20 pd-b20 pd-l30">
                    <div class="cards__item--infobox  position-relative d-flex flex-column mg-r20 pd-t15 pd-b15 pd-l15 pd-r15 light-bg"
                        [ngClass]="{'no-habit-drills-pad br-5': item?.courseHabitDrills && !item?.courseHabitDrills.length }">
                        <div class="locked-overlay"></div>
                        <p class="card__item--title dark-color">{{item?.masterclassAlias ? item.masterclassAlias :
                            'Masterclass'}} - {{item?.title}}</p>
                        <p class="mandatory" *ngIf="!item?.isOptionalToComplete">mandatory</p>
                        <a class="item-live live-top link-no-underline light-color"
                            *ngIf="!item.masterClassObjects[0]?.recordedLink && !item.status.islock && !item.status.upcoming && !item.status.isMeetingEnd">
                            {{!item.masterClassObjects[0]?.recordedLink && !item.status.islock && !item.status.upcoming ?'Live Now' :''}}
                        </a>
                        <div class="card__item--disabled--link">
                            <div class="hover--liveclass">
                                <a class="seedetailsBtn primary-color link-no-underline mg-t20 cursor-pointer"
                                    *ngIf="item?.masterClassObjects && item?.masterClassObjects.length && item?.masterClassObjects[0]?.date && item?.description && item?.title"
                                    (mouseenter)="masterclassDetailsEvent($event, item)">
                                    See Details</a>
                                <div class="card__item--hoverspeaker">
                                    <h5 class="card__item--classtitle dark-color text-capitalize">
                                        {{item?.masterclassAlias ? item.masterclassAlias : 'Masterclass'}} -
                                        {{item?.title}}
                                    </h5>
                                    <p class="card__item--classdesc dark-color mg-t15">{{item?.description}}</p>
                                    <ng-container
                                        *ngIf="item?.masterClassObjects && item?.masterClassObjects.length && item?.masterClassObjects[0]?.date">
                                        <p class="card__item--classdesc masterclass-started dark-color mg-t15"
                                            *ngIf="!item?.status?.isMeetingEnd">
                                            Start at {{item?.masterClassObjects[0]?.date | date: dateFormat}}</p>
                                        <p class="card__item--classdesc masterclass-ended dark-color mg-t15"
                                            *ngIf="item?.status?.isMeetingEnd">
                                            {{item?.masterclassAlias ? item.masterclassAlias : 'Masterclass'}} ended at
                                            {{item?.masterClassObjects[0]?.endDate |
                                            date:dateFormat}}</p>
                                    </ng-container>
                                    <ng-container
                                        *ngIf="item?.masterClassObjects && item?.masterClassObjects.length && item?.masterClassObjects[0]?.faculty && item?.masterClassObjects[0]?.faculty.name">
                                        <p class="card__item--classdesc dark-color mg-t15">Faculty:</p>
                                        <div class="d-flex card__item--faculty pd-t10">
                                            <div class="card__item--faculty--pic">
                                                <img [src]="item?.masterClassObjects && item?.masterClassObjects[0]?.faculty?.profilePic"
                                                    alt="">
                                            </div>
                                            <div class="pd-l10">
                                                <h6 class="card__item--faculty--name">{{ item?.masterClassObjects &&
                                                    item?.masterClassObjects[0]?.faculty?.name | titlecase}}</h6>
                                                <p class="card__item--faculty--job">{{ item?.masterClassObjects &&
                                                    item?.masterClassObjects[0]?.faculty?.designation}}
                                                </p>
                                                <p class="card__item--faculty--desc">{{item?.masterClassObjects &&
                                                    item?.masterClassObjects[0]?.faculty?.shortBio}}</p>
                                                <a class="cursor-pointer"
                                                    *ngIf="item?.masterClassObjects && item?.masterClassObjects[0]?.faculty?.linkedIn">
                                                    <img src="assets/images/linkedin-full.svg" width="16" alt=""
                                                        (click)="navigateLinkedIn(item?.masterClassObjects[0]?.faculty?.linkedIn)">
                                                </a>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                        <ng-container
                            *ngIf="item?.masterClassObjects && item?.masterClassObjects.length && item?.masterClassObjects[0]?.date">
                            <p class="dark-color masterclass-started time-info" *ngIf="!item?.status?.isMeetingEnd">
                                {{item?.masterClassObjects[0]?.date | date:'shortTime'}} -
                                {{item?.masterClassObjects[0]?.endDate | date: 'shortTime'}},
                                {{item?.masterClassObjects[0]?.date | date:'d LLLL yyyy'}}
                            </p>
                            <p class="dark-color masterclass-ended time-info" *ngIf="item?.status?.isMeetingEnd">
                                {{item?.masterclassAlias ? item.masterclassAlias : 'Masterclass'}} ended at
                                {{item?.masterClassObjects[0]?.endDate | date: dateFormat}}
                            </p>
                        </ng-container>
                        <!-- <a class="item-live link-no-underline light-color"
                            *ngIf="!item.recordedLink && !item.status.islock && !item.status.upcoming && !item.status.isMeetingEnd">
                            {{!item.recordedLink && !item.status.islock && !item.status.upcoming ?'Live Now' :''}}
                        </a> -->
                        <div class="cards__item--rightside yellow-bg position-relative">
                            <div class="btnBg yellow-bg d-flex align-items-center">
                            </div>
                            <a class="live-btn light-color cursor-pointer"
                                (click)="startZoom(item?.masterClassObjects[0]._id, item.programDashboardId, item)">
                                {{ item.masterClassObjects[0]?.recordedLink && item.masterClassObjects[0]?.recordedLink!=='' ? 'Watch Recording':
                                item.status.isMeetingEnd ? 'Recording Awaited' :
                                !item.status.islock && !item.status.upcoming ?'Enter Live Sesion': 'Upcoming' }} </a>
                        </div>
                    </div>
                    <div class="is-enabled--msg position-relative br-bottom wrap-flex"
                        *ngIf="item?.courseHabitDrills && item?.courseHabitDrills.length">
                        <div class="locked-overlay"></div>
                        <ng-container *ngFor="let habit of item?.courseHabitDrills; let i = index">
                            <a (click)="habitDrillDetails(item, habit)" target="_blank"
                                class="link-no-underline cursor-pointer">
                                <span *ngIf="item.status.progress != 100" class="icon-padlock-1 font-10 lock-icon"></span>
                                <span *ngIf="item.status.progress == 100" class="material-symbols-outlined font-10">
                                   lock_open
                                   </span>
                                {{dynamicHabitDrillNomenclature}} {{i+1}}
                            </a>
                        </ng-container>
                    </div>
                    <!-- <div class="is-locked-warning position-relative" *ngIf="item?.status?.msg"
                        [ngClass]="{'no-habit-drills': item?.courseHabitDrills && !item?.courseHabitDrills.length }">
                        <a class="link-no-underline">
                            <span class="icon-warning font-10 lock-icon"></span>
                            {{item?.status?.msg}}
                        </a>
                    </div> -->
                </div>
            </div>
            <!-- Mobile masterclass end -->

            <!-- Mobile course card start -->
            <div class="cards__item d-flex" *ngIf="item?.type == 'COURSE'"
                [ngClass]="{'is-enabled current-task': !item.status.islock && !item.status.started ,'is-started': item.status.progress < 100 && item.status.started, 'is-done': item.status.progress ==100,'is-locked':item.status.islock }">
                <p class="cards__icon--bg"></p>
                <div class="is-started-progress ">
                    <circle-progress [percent]="item?.status?.progress|number:'1.0-0'" [radius]="16" [space]="-3"
                        [toFixed]="0" [maxPercent]="100" [unitsFontSize]="9" [unitsColor]="'#44A659'"
                        [outerStrokeWidth]="4" [outerStrokeColor]="'#44A659'" [innerStrokeColor]="'#D5D5D5'"
                        [innerStrokeWidth]="1" [titleColor]="'#44A659'" [titleFontSize]="10" [subtitleFontSize]="5">
                    </circle-progress>
                </div>
                <div class="cards__item--info position-relative pd-t15 pd-b15 pd-l60">
                    <div class="cards__item--infobox br-top position-relative d-flex flex-column mg-r20 pd-t15 pd-b15 pd-l15 pd-r15 light-bg"
                        [ngClass]="{'no-habit-drills-pad br-5': item?.courseHabitDrills && !item?.courseHabitDrills.length }">
                        <div class="locked-overlay"></div>
                        <div class="d-flex w-100">
                            <div class="card__item--img">
                                <span
                                    class="cards__item--timer primary-color light-bg link-no-underline cursor-pointer">
                                    {{(item.duration <= 3600)?(item.duration | formateSeconds: 'absoluteMinutes'
                                        ):(item.duration | formateSeconds: 'hourMinute' )}} </span>
                                        <!-- <a class="cards__item--trailer primary-color light-bg link-no-underline cursor-pointer"
                                    (click)="showModal(item)">
                                    COURSE PREVIEW
                                </a> -->
                                        <img style="max-width: 340px;" (click)="showModal(item)" *ngIf="!item.courseDisableIntroVideo"
                                            class="player_gif" src="/assets/images/gif/play_circle.svg">
                                        <!-- <img src="assets/images/e8c64c.png" alt=""> -->
                                        <img style="max-width: 340px;" [src]="item?.introVideoThumbnailUrl" (click)="showModal(item)" alt=""
                                            class="cursor-pointer">
                                        <!-- <a (click)="startCourse('COURSE', item.courseId, item.programDashboardId,item)" class="card__item--link-xs"
                                    [ngClass]="{'no-habit-drills-xs-btn': item?.courseHabitDrills && !item?.courseHabitDrills.length }">
                                    <img style="max-width: 340px;" class="player_gif" src="/assets/images/gif/playicon.gif">
                                </a> -->
                            </div>
                            <ul class="card__item--details dark-color time-block">
                                <!-- <li class=" pd-l10 ">5 Questions</li> -->
                                <!-- <li class=" pd-l10">Estimated Time: {{(item.duration / 60) | number : '1.0-0'}} min</li> -->
                                <!-- <li *ngIf="item?.duration <= 3600" class="pd-l10">Estimated Time123: {{item?.duration |
                                    formateSeconds: 'absoluteMinutes'}}</li>
                                <li *ngIf="item?.duration > 3600" class="pd-l10">Estimated Time123: {{item?.duration |
                                    formateSeconds: 'hourMinute'}}</li> -->
                                <li class="recommendText pd-l30 pd-b10" *ngIf="(item?.deadLineDate|date: 'shortDate') >= todayDate &&
                                    prog.activation.enableProgramTimer &&
                                    item?.status?.progress!=100">
                                    Recommended to complete by <span>{{item?.deadLineDate|date: 'd/M/yy'}}</span>
                                </li>
                            </ul>
                        </div>
                        <div class="card__item--right">

                            <div class="mg-t15 card__item--titlebox">
                                <p class="card__item--title dark-color">{{item?.title | lowercase}}
                                </p>
                                <p class="mandatory" *ngIf="!item?.isOptionalToComplete">mandatory</p>
                                <p class="card__item--desc">{{item?.description}}</p>
                            </div>
                            <a (click)="startCourse('COURSE', item.courseId, item.programDashboardId,item, $event)"
                                class="card__item--link-xs link-no-underline primary-color cursor-pointer"
                                [ngClass]="{'no-habit-drills-xs-btn': item?.courseHabitDrills && !item?.courseHabitDrills.length }">
                                {{(item?.status?.started && item?.status?.progress < 100 ) ? 'RESUME LEARNING' :
                                    (item?.status?.progress==100) ? 'REVISE' : 'START LEARNING' }}</a>
                        </div>
                    </div>
                    <div class="is-enabled--msg position-relative br-bottom wrap-flex"
                        *ngIf="item?.courseHabitDrills && item?.courseHabitDrills.length">
                        <div class="locked-overlay"></div>
                        <ng-container *ngFor="let habit of item?.courseHabitDrills; let i = index">
                            <a (click)="habitDrillDetails(item, habit)" target="_blank"
                                class="link-no-underline cursor-pointer">
                                <span *ngIf="item.status.progress != 100" class="icon-padlock-1 font-10 lock-icon"></span>
                                <span *ngIf="item.status.progress == 100" class="material-symbols-outlined font-10">
                                   lock_open
                                   </span>
                                {{dynamicHabitDrillNomenclature}} {{i+1}}
                                <!-- Habit Drill: Impactful activity designed to build your Thrive Skills.
                                <span class="lock-msg">Habit Drill will
                                    unlock after completion of this course</span> -->
                            </a>
                        </ng-container>
                    </div>
                    <!-- <div class="is-locked-warning position-relative" *ngIf="item?.status?.msg"
                        [ngClass]="{'no-habit-drills': item?.courseHabitDrills && !item?.courseHabitDrills.length }">
                        <a class="link-no-underline">
                            <span class="icon-warning font-10 lock-icon"></span>
                            {{item?.status?.msg}}
                        </a>
                    </div> -->
                    <!-- <div class="is-locked-warning position-relative" *ngIf="item.courseId == lockedCardMsg.courseId"
                        [ngClass]="{'no-habit-drills': item?.courseHabitDrills && !item?.courseHabitDrills.length }">
                        <a class="link-no-underline" *ngIf="lockedCardMsg.type == 'PRE'">
                            <span class="icon-warning font-10 lock-icon"></span>
                            {{lockedCardMsg.msg}}
                        </a>
                        <a class="link-no-underline" *ngIf="lockedCardMsg.type == 'SEQUENCE'">
                            <span class="icon-warning font-10 lock-icon"></span>
                            Complete {{lockedCardMsg.courseName | titlecase}} to unlock this course
                        </a>
                        <a class="link-no-underline" *ngIf="lockedCardMsg.type == 'DATE'">
                            <span class="icon-warning font-10 lock-icon"></span>
                            {{lockedCardMsg.msg}} {{lockedCardMsg.date | date: 'EEEE, MMMM d, y'}}
                            {{(lockedCardMsg?.dateNotPassed) ? ', after completing the '+ preTitle +'.' : '' }}
                        </a>
                    </div>
                    <div class="is-locked-warning position-relative"
                        *ngIf="(item.courseId != lockedCardMsg.courseId) && lockedCardMsg.type == 'DATE' && item?.status?.islock">
                        <a class="link-no-underline">
                            <span class="icon-warning font-10 lock-icon"></span>
                            <ng-container *ngIf="item?.isPreDone && !item?.isDatePassed">
                                This course will unlock on {{ item.course_StartDate | date: 'EEEE, MMMM d, y'}}
                            </ng-container>
                            <ng-container *ngIf="!item?.isPreDone && !item?.isDatePassed">
                                This course will unlock on {{ item.course_StartDate | date: 'EEEE, MMMM d, y'}}, after
                                completing the {{preTitle}}.
                            </ng-container>
                            <ng-container *ngIf="!item?.isPreDone && item?.isDatePassed">
                                This course will unlock after completing the {{preTitle}}.
                            </ng-container>
                        </a>
                    </div> -->
                </div>
            </div>
            <!-- Mobile course card end -->
            <!-- Mobile post exercise card start -->
            <div class="cards__item d-flex" *ngIf="item?.type == 'POST'" [ngClass]="{
                'is-enabled current-task': !item?.status?.islock && (item?.status?.progress < 100),
                'is-locked':item?.status?.islock,
                'is-done':item?.status?.progress == 100}">

                <p class="cards__icon--bg"></p>
                <div class="cards__item--info position-relative pd-t15 pd-b15 pd-l60">
                    <div
                        class="cards__item--infobox br-5 position-relative d-flex flex-column mg-r20 pd-t15 pd-b15 pd-l15 pd-r15 light-bg">
                        <div class="d-flex w-100">
                            <div class="locked-overlay"></div>
                            <div class="card__item--img">
                                <span
                                    class="cards__item--timer primary-color light-bg link-no-underline cursor-pointer">
                                    {{(item.exercise.duration <= 3600)?(item.exercise.duration |
                                        formateSeconds: 'absoluteMinutes' ):(item.exercise.duration |
                                        formateSeconds: 'hourMinute' )}} </span>
                                        <!-- <img src="assets/images/e8c64c.png" alt=""> -->
                                        <!-- <img src="assets/images/base/basecamp.png" alt="basecamp"> -->
                                        <img style="max-width: 340px;" src="assets/images/post-program-assessment-icon.png" alt="submit">
                            </div>
                            <ul class="card__item--details dark-color time-block">
                                <!-- <li class=" pd-l10 ">5 Questions</li> -->
                                <!-- <li class=" pd-l10">Estimated Time: {{(item.duration / 60) | number : '1.0-0'}} min</li> -->
                                <!-- <li *ngIf="item?.duration <= 3600" class="pd-l10">Estimated Time123: {{item?.duration |
                                    formateSeconds: 'absoluteMinutes'}}</li>
                                <li *ngIf="item?.duration > 3600" class="pd-l10">Estimated Time123: {{item?.duration |
                                    formateSeconds: 'hourMinute'}}</li> -->
                                <li class="recommendText pd-l30 pd-b10" *ngIf="(item?.deadLineDate|date: 'shortDate') >= todayDate &&
                                    prog.activation.enableProgramTimer &&
                                    item?.status?.progress!=100">
                                    Recommended to complete by <span>{{item?.deadLineDate|date: 'd/M/yy'}}</span>
                                </li>
                                <li class="d-inline pd-r10">
                                    {{item?.exercise?.totalQuestions}}
                                    {{(item?.exercise?.totalQuestions > 1) ?
                                    'Questions' : 'Question' }}</li>
                            </ul>
                            <!-- <ul class="card__item--details dark-color">
                        <li class=" pd-l10 ">
                            {{prog?.benchmarkingAssessments[1]?.exercise.pages[0].elements.length}}
                            {{(prog?.benchmarkingAssessments[1]?.exercise.pages[0].elements.length > 1) ?
                            'Questions' : 'Question' }}</li>
                        <li class="pd-l10">Estimated Time: {{prog?.benchmarkingAssessments[1]?.exercise?.duration | formateSeconds: 'absoluteMinutes'}}</li>


                    </ul> -->
                        </div>
                        <div class="card__item--right">

                            <div class="mg-t15 card__item--titlebox">
                                <p class="card__item--title dark-color">
                                    {{item?.title || 'Summit'}} </p>
                                <p class="mandatory" *ngIf="!item?.isOptionalToComplete">mandatory</p>
                                <ul class="card__item--details dark-color">
                                    <!-- <li class="d-inline pd-l10 pd-r10">
                                    {{item?.exercise?.pages[0]?.elements?.length}}
                                    {{(item?.exercise?.pages[0]?.elements?.length > 1) ?
                                    'Questions' : 'Question' }}</li> -->
                                    <!-- <li class="d-inline pd-l10 pd-r10">Estimated Time:
                                {{(prog?.benchmarkingAssessments[0]?.exercise?.duration /
                                60) | number : '1.0-0'}} min </li> -->
                                    <!-- <li class="d-inline pd-l10 pd-r10">Estimated Time123: {{item?.exercise?.duration |
                                    formateSeconds: 'absoluteMinutes'}}</li> -->
                                    <!-- <span>7</span> -->

                                </ul>
                                <p class="card__item--desc">{{ item?.description ? item?.description : 'The program is
                                    over. See how you fare on Thrive Skills now!' }}</p>
                            </div>
                            <a *ngIf="item?.status?.progress<100 || (prog.activation?.showPrePostTestResults != false && item?.status?.progress==100)"
                                (click)=navigateToPostTest(item)
                                class="card__item--link-xs link-no-underline primary-color cursor-pointer">
                                {{(item?.status?.started &&
                                item?.status?.progress < 100 ) ? 'RESUME TEST' : (item?.status?.progress==100)
                                    ? 'VIEW FEEDBACK' : 'BEGIN TEST' }} </a>
                        </div>
                    </div>
                    <!-- <div class="is-locked-warning position-relative bottom--msg" *ngIf="item?.status?.msg">
                        <a class="link-no-underline">
                            <span class="icon-warning font-10 lock-icon"></span>
                            {{item?.status?.msg}}
                        </a>
                    </div> -->
                </div>
            </div>
            <!-- Mobile post exercise card end -->
        </ng-container>
        <!-- Mobile course / masterclass end -->

        <!-- Mobile certificate start  -->
        <div class="cards__item is-disabled-reports d-flex" [ngClass]="{
            'is-enabled current-task': program[0]?.progress == 100 && program[0]?.isFeedbackSubmitted,
            'is-disabled':!program[0]?.progress || program[0]?.progress < 100
           }">
            <p class="cards__icon--bg"></p>
            <div class="cards__item--info position-relative pd-t20 pd-b20 pd-l30">
                <div class="cards__item--infobox br-5 position-relative d-flex align-items-center mg-r20 pd-t15 pd-b15 pd-l20 pd-r20 light-bg cursor-pointer"
                    style="outline: none;" (click)="goToReportCertificate()">
                    <div class="locked-overlay"></div>
                    <p class="cards__item--reports d-flex">
                        <img src="assets/images/medal.svg" width="17" height="20" alt="" class="mg-r10">
                        <ng-container
                            *ngIf="prog?.activation?.enableProgramCertificate && prog?.activation?.showProgramPerformanceReport">
                            Certificate & Transcript
                        </ng-container>
                        <ng-container
                            *ngIf="!(prog?.activation?.enableProgramCertificate && prog?.activation?.showProgramPerformanceReport)">
                            {{(prog?.activation?.enableProgramCertificate && !isProgramCompletionDatePassed) ||
                            (prog?.activation?.enableProgramCertificate && prog.dashboard[0].status.progress == 100) ?
                            "Certificate" : "Transcript"}}
                        </ng-container>
                    </p>
                </div>
            </div>
        </div>
        <!-- Mobile certificate end  -->

    </div>
    <!-- Mobile cards end -->

</article>

<app-static-player *ngIf="showMobal" (modelOpen)="closeModel($event)" [type]="modalData?.type"
    [status]="modalData?.status" [file]="modalData?.introVideoUrl" [autoStart]="true" [isInPopup]="false"
    [thumb]="modalData?.introVideoThumbnailUrl" [videoTitle]="modalData?.introVideoTitle"
    [videoDesc]="modalData?.introVideoDescription" [item]="modalData">
</app-static-player>

<app-static-player *ngIf="showMasterclass" (modelOpen)="closeMasterClassModal($event)" [type]="'MASTERCLASS'"
    [status]="masterClassModalData?.status" [file]="masterClassModalData?.masterClassObjects[0].recordedLink" [autoStart]="true"
    [isInPopup]="false" [videoDuration]="masterClassModalData?.masterClassObjects[0].recordedLinkDuration"
    [videoTitle]="masterClassModalData?.title" [videoDesc]="masterClassModalData?.description"
    [masterVideoObj]="masterVideoObj"></app-static-player>

<!-- optional popover on course/masterclass -->
<app-optional-item-popover *ngIf="optionalModal" (skipItem)="skipOptionalBlock($event)"
    (startCurrentItem)="startCurrentBlockItem($event)" (hideOptionalModal)="optionalModalHide($event)">
</app-optional-item-popover>